module.exports = __webpack_public_path__ + "media/site_templates/www.roofingcompany.net.au/images/about_us-24dd66912925c9df67cdf9f5c766873a.jpg";